import type { Cart } from "@packages/sdk";

import { MS_DAY } from "../lib/constants/days.constants";
import { getDateSanitized } from "./getDateSanitized";

type GetTrialLengthProps = { cart?: Cart };

export const getTrialLength = ({ cart }: GetTrialLengthProps) => {
  if (cart)
    return Math.floor(
      (getDateSanitized({ date: new Date(cart.trial_end_date) }) -
        getDateSanitized({ date: new Date() })) /
        MS_DAY,
    );

  return null;
};
